import { selectFilteredLinesAggs } from './selectors.filteredLinesAggs';

export { 
  selectFilteredLinesAggs
}

export default {
  selectFilteredLinesAggs
}